var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2362 4.96378L19.0362 11.7637C20.3218 13.0494 20.3218 15.1324 19.0362 16.4181L15.4185 20.0358C14.1328 21.3214 12.0498 21.3214 10.7641 20.0358L3.96418 13.2358C3.2029 12.4746 2.86175 11.3886 3.05152 10.3278L4.00587 5.00546L9.32824 4.05112C10.389 3.86245 11.475 4.2025 12.2362 4.96378Z",
    stroke: "#171718",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0365 9.57075C10.0365 10.3803 9.38027 11.0365 8.57075 11.0365C7.76122 11.0365 7.10497 10.3803 7.10497 9.57075C7.10497 8.76122 7.76122 8.10497 8.57075 8.10497C9.38027 8.10497 10.0365 8.76122 10.0365 9.57075Z",
    stroke: "#171718",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.17bd86f1513c3d4a5d43f1ac5b8cd71b.svg";
export { ForwardRef as ReactComponent };